export const config = {
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
  // In development: use Firebase Functions emulator
  // In production: use relative paths with Firebase Hosting rewrites
  apiBaseUrl: import.meta.env.DEV
    ? 'http://127.0.0.1:5001/sheer-ai/us-central1'
    : '/api',
  firebase: {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
  },
  emulators: {
    useEmulators: import.meta.env.DEV,
    authHost: 'localhost',
    authPort: 9099,
    firestoreHost: 'localhost',
    firestorePort: 8080,
  },
} as const;
